export default __webpack_public_path__ + "static/media/battery-power-high.dd39b6dd.svg";